<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <el-tabs v-model="queryForm.status" @tab-click="search">
      <el-tab-pane label="全部" name="-1"></el-tab-pane>
      <el-tab-pane label="待打款" name="0"></el-tab-pane>
      <el-tab-pane label="打款成功" name="1"></el-tab-pane>
      <el-tab-pane label="打款失败" name="2"></el-tab-pane>
    </el-tabs>
    <div class="query-form">
      <el-form label-position="right" label-width="70px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="30">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="提现单号">
                  <el-input v-model="queryForm.serialNumber" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="店铺名称">
                  <el-input v-model="queryForm.vendorName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="商务运营">
                  <el-select v-model="queryForm.boutiqueDBId" filterable clearable placeholder="请选择">
                    <el-option v-for="item in userList" :label="item.deptUserName" :value="item.deptUserId" :key="item.deptUserId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="运营助理">
                  <el-select v-model="queryForm.boutiqueAssistantId" filterable clearable placeholder="请选择">
                    <el-option v-for="item in userList" :label="item.deptUserName" :value="item.deptUserId" :key="item.deptUserId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="银行卡号">
                  <el-input v-model="queryForm.bankNum" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="预留电话">
                  <el-input v-model="queryForm.phoneNum" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="申请日期">
                  <el-date-picker
                    style="width:100%"
                    v-model="daterange"
                    type="daterange"
                    value-format="timestamp"
                    :editable="false"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="提现方式">
                  <el-select v-model="queryForm.withdrawalWay" clearable placeholder="请选择">
                    <el-option label="普通提现" :value="1"></el-option>
                    <!-- <el-option label="支付宝" :value="2"></el-option> -->
                    <el-option label="极速提现" :value="3"></el-option>
                    <el-option label="商盟提现" :value="4"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="15" :md="15" :lg="10" :xl="8">
                <el-form-item label="更新时间">
                  <el-date-picker
                    style="width:100%"
                    v-model="updateDaterange"
                    type="datetimerange"
                    value-format="timestamp"
                    format="yyyy-MM-dd HH:mm:ss"
                    :editable="false"
                    :default-time="['00:00:00', '23:59:59']"
                    :picker-options="{
                  selectableRange: '00:00:00 - 23:59:59'}"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="toolbar">
      <div class="ml_bold">
        <el-button v-if="queryForm.status == '0'" @click="batchSuccess" :disabled="multipleSelection.length === 0" type="primary">打款成功</el-button>
        <span style="margin-left: 5px">需打款金额合计: {{selectedAmount}}</span>
      </div>
      <div>
        <el-dropdown class="ml10" @command="handleExport" :disabled="exporting">
          <el-button plain type="primary" :loading="exporting">导出<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="csv">CSV</el-dropdown-item>
            <el-dropdown-item command="excel">Excel</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span class="ml20" v-if="exportFileName">上一次导出结果：<el-link type="primary" @click="downloadExportResult">{{ exportFileName }}</el-link></span>
        <span class="ml20 red" v-if="exportFailed">导出失败</span>
      </div>
    </div>
    <el-table :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="serialNumber" label="提现单据号"></el-table-column>
      <el-table-column prop="vendorName" label="店铺名称"></el-table-column>
      <el-table-column label="商务/运营助理">
        <template slot-scope="scope">
          {{ scope.row.boutiqueDBName }}/{{ scope.row.boutiqueAssistantName }}
        </template>
      </el-table-column>
      <el-table-column prop="applyAmount" label="提现金额"></el-table-column>
      <el-table-column prop="serviceFee" label="提现手续费"></el-table-column>
      <el-table-column prop="amount" label="需打款金额"></el-table-column>
      <el-table-column label="提现方式">
        <template slot-scope="scope">
          <template v-if="scope.row.withdrawalWay === 1">普通提现</template>
          <template v-if="scope.row.withdrawalWay === 3">极速提现</template>
          <template v-if="scope.row.withdrawalWay === 4">商盟提现</template>
        </template>
      </el-table-column>
      <el-table-column label="提现账户" width="500">
        <template slot-scope="scope">
          <template v-if="scope.row.withdrawalWay === 3">{{ scope.row.merchantUserName }}/{{ scope.row.bankName }}/{{ scope.row.bankNumber }}/{{ scope.row.phoneNum }}/{{ scope.row.userIdNumber }}</template>
          <template v-if="scope.row.withdrawalWay === 2">{{ scope.row.thirdPartyAccount }}</template>
          <template v-if="scope.row.withdrawalWay === 1 || scope.row.withdrawalWay === 4">{{ scope.row.merchantUserName }}/{{ scope.row.bankName }}/{{ scope.row.bankBranchName }}/{{ scope.row.bankNumber }}/{{ scope.row.phoneNum }}/{{ scope.row.userIdNumber }}</template>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          {{ statusMap[scope.row.status] }}
        </template>
      </el-table-column>
      <el-table-column label="申请时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.createAt) }}
        </template>
      </el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.applyAt) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.withdrawalWay === 1 && scope.row.status == 0" @click="showSuccess(scope.row)">打款成功</el-link>
          <el-link type="primary" class="ml10" v-if="scope.row.withdrawalWay === 1 && scope.row.status == 0" @click="showFail(scope.row)">打款失败</el-link>
          <el-link type="primary" class="ml10" v-if="scope.row.withdrawalWay === 1 && scope.row.status != 0" @click="showDetail(scope.row)">打款详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="打款确认" :visible.sync="dialogVisible1" width="400px">
      <p class="title">确认打款成功？</p>
      <dl>
        <dt>打款金额</dt>
        <dd><span class="money">¥{{ successForm.amount }}</span></dd>
      </dl>
      <p class="subtitle">账户信息</p>
      <dl>
        <dt>账户类型：</dt>
        <dd>银行账户</dd>
      </dl>
      <dl>
        <dt>真实姓名：</dt>
        <dd>{{ successForm.merchantUserName }}</dd>
      </dl>
      <dl>
        <dt>银行卡号：</dt>
        <dd>{{ successForm.bankNumber }}({{ successForm.bankName }})</dd>
      </dl>
      <dl>
        <dt>打款凭证：</dt>
        <dd>
          <el-upload class="upload-withdraw" multiple :file-list="successForm.fileListJson" :limit="10" :http-request="handleHttpRequest" action="" accept=".png,.jpg,.jpeg,.pdf,.xls,.xlsx" :on-success="handleSuccess" :on-remove="onRemove" :on-exceed="onExceed">
            <el-button type="text">上传文件</el-button>
          </el-upload>
        </dd>
      </dl>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submitSuccessForm">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="打款确认" :visible.sync="dialogVisible2" width="400px">
      <p class="title">确认打款失败？</p>
      打款失败原因：
      <el-select v-model="failForm.exceptionId" placeholder="请选择原因" style="width: 200px">
        <el-option v-for="item in exceptionList" :label="item.reason" :value="item.exceptionId" :key="item.exceptionId"></el-option>
      </el-select>
      <el-input class="mt10" :rows="5" resize="none" type="textarea" v-model="failForm.remark" :maxlength="50" placeholder="请描述具体失败原因，50字以内"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitFailForm">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="打款详情" :visible.sync="dialogVisible3" width="400px">
      <template v-if="detailForm.status == 2">
        <p class="title">打款失败！</p>
        <p>{{ getExceptionStr(detailForm.exceptionId) }}{{ detailForm.remark ? '：' + detailForm.remark : '' }}</p>
      </template>
      <template v-if="detailForm.status == 1">
        <p class="title">打款成功！</p>
        <dl>
          <dt>打款金额</dt>
          <dd><span class="money">¥{{ detailForm.amount }}</span></dd>
        </dl>
        <p class="subtitle">账户信息</p>
        <dl>
          <dt>账户类型：</dt>
          <dd>{{ detailForm.withdrawalWay === 1 ? '银行账户' : '支付宝'}}</dd>
        </dl>
        <dl>
          <dt>真实姓名：</dt>
          <dd>{{ detailForm.merchantUserName }}</dd>
        </dl>
        <dl>
          <dt>{{ detailForm.withdrawalWay === 1 ? '银行卡号' : '支付宝'}}：</dt>
          <dd v-if="detailForm.withdrawalWay === 1">{{ detailForm.bankNumber }}({{ detailForm.bankName }})</dd>
          <dd v-else>{{ detailForm.bankNumber }}</dd>
        </dl>
        <dl v-if="detailForm.withdrawalWay === 1">
          <dt>打款凭证：</dt>
          <dd>
            <el-upload class="upload-withdraw" multiple :file-list="detailForm.fileListJson" :limit="10" :http-request="handleHttpRequest" action="" accept=".png,.jpg,.jpeg,.pdf,.xls,.xlsx" :on-success="handleSuccess" :on-remove="onRemove" :on-exceed="onExceed">
              <el-button type="text">上传文件</el-button>
            </el-upload>
            <span v-if="detailForm.paymentVoucherUrl.length === 0">无</span>
            <el-link class="ml10" v-for="(file, index) in detailForm.paymentVoucherUrl" :key="index" type="primary" :href="file.url" target="_blank">{{ file.name }}</el-link>
          </dd>
        </dl>
      </template>
    </el-dialog>

    <el-dialog append-to-body title="提示" :visible.sync="dialogVisible4" width="400px">
      <p class="title">导入失败！</p>
      <p v-for="(item, index) in importResult" :key="index">{{ item }}</p>
    </el-dialog>

    <el-dialog append-to-body title="打款确认" :visible.sync="dialogVisible5" width="400px">
      <p class="title">确认打款成功？</p>
      <dl>
        <dt>打款金额</dt>
        <dd><span class="money">¥{{ successForm.amount }}</span></dd>
      </dl>
      <dl>
        <dt>打款笔数</dt>
        <dd><span class="money">{{ multipleSelection.length }}笔</span></dd>
      </dl>
      <dl>
        <dt>打款凭证：</dt>
        <dd>
          <el-upload class="upload-withdraw" multiple :file-list="successForm.fileListJson" :limit="10" :http-request="handleHttpRequest" action="" accept=".png,.jpg,.jpeg,.pdf,.xls,.xlsx" :on-success="handleSuccess" :on-remove="onRemove" :on-exceed="onExceed">
            <el-button type="text">上传文件</el-button>
          </el-upload>
        </dd>
      </dl>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="submitBatchSuccessForm">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="打款结果" :visible.sync="dialogVisible6" :close-on-click-modal="false" width="600px">
      <p class="money" v-html="batchSuccessResult"></p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible6 = false">关 闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  getApplyList,
  getVendorList,
  updateSettlementApply,
  batchUpdateSettlementApply,
  getExceptionList,
  exportSettlementApply,
  downloadSample,
  importSettlementApply,
  voucherUpload,
  exportSettlementResult,
} from "./api";
import { fileUpload } from "../../../api/merchants";
import { getUserList } from '../../buyershop/api';
import { downloadUrlFile } from '@/utils/functions';
import Client from "@/utils/client.js";
import utils from '@/utils/util';

export default {
  computed: mapState({
    userDetail: state => state.user.userDetail,
  }),
  data() {
    return {
      fullscreenLoading: false,
      queryForm: {
        serialNumber: null,
        vendorName: null,
        boutiqueDBId: null,
        boutiqueAssistantId: null,
        bankNum: null,
        phoneNum: null,
        withdrawalWay: null,
        status: '-1',
        pageNo: 1,
        pageSize: 25,
      },
      updateDaterange: [],
      daterange: [],
      vendorList: [],
      userList: [],
      tableData: [],
      total: 0,
      statusMap: {
        0: '待打款',
        1: '打款成功',
        2: '打款失败'
      },
      selectedAmount: 0,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      successForm: {
        applyId: null,
        amount: null,
        merchantUserName: null,
        bankName: null,
        bankNumber: null,
        fileListJson: [],
        withdrawalWay: null,
      },
      exceptionList: [],
      failForm: {
        applyId: null,
        exceptionId: null,
        remark: '',
      },
      detailForm: {},
      importResult: [],
      dialogVisible4: false,
      multipleSelection: [],
      dialogVisible5: false,
      dialogVisible6: false,
      batchSuccessResult: '',
      exporting: false,
      exportFileName: '',
      exportFailed: false,
    };
  },
  mounted() {
    getVendorList().then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data;
      }
    })
    getUserList().then(res => {
      if (res.data) {
        this.userList = res.data;
      }
    })
    getExceptionList().then(res => {
      if (res.data && res.data.data) {
        this.exceptionList = res.data.data;
      }
    })
    this.getTableData();
    this.getExportResult();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.serialNumber = null;
      this.queryForm.accountName = null;
      this.queryForm.vendorName = null;
      this.queryForm.boutiqueDBId = null;
      this.queryForm.boutiqueAssistantId = null;
      this.queryForm.bankNum = null;
      this.queryForm.phoneNum = null;
      this.queryForm.withdrawalWay = null;
      this.updateDaterange = [];
      this.daterange = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getApplyList({
        ...this.queryForm,
        startApplyAt: this.daterange[0] ? this.daterange[0] : null,
        endApplyAt: this.daterange[1] ? this.daterange[1] : null,
        startUpdateAt: this.updateDaterange && this.updateDaterange[0] ? this.updateDaterange[0] : null,
        endUpdateAt: this.updateDaterange && this.updateDaterange[1] ? this.updateDaterange[1] : null,
        status: this.queryForm.status == -1 ? null : this.queryForm.status,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    showSuccess(row) {
      this.successForm.applyId = row.applyId;
      this.successForm.amount = row.amount;
      this.successForm.merchantUserName = row.merchantUserName;
      this.successForm.bankName = row.bankName;
      this.successForm.bankNumber = row.bankNumber;
      this.successForm.fileListJson = [];
      this.repeatSave = false;
      this.dialogVisible1 = true;
    },
    submitSuccessForm() {
      if (this.repeatSave) {
        return;
      }
      this.repeatSave = true;
      updateSettlementApply({
        ...this.successForm,
        fileListJson: JSON.stringify(this.successForm.fileListJson.map(item => {
        if (item.response) {
          return {
            name: item.name,
            url: item.response.url,
          }
        }
        return {
          name: item.name,
          url: item.url,
        }
      })),
        status: 1,
        operationUserName: this.userDetail.name,
      }).then(res => {
        this.repeatSave = false;
        if (res.data.success) {
          this.$message.success('打款确认成功');
          this.dialogVisible1 = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.data || res.data.message);
        }
      }).catch((err) => {
        this.repeatSave = false;
      })
    },
    showFail(row) {
      this.failForm.applyId = row.applyId;
      this.failForm.exceptionId = row.exceptionId;
      this.failForm.remark = '';
      this.repeatSave = false;
      this.dialogVisible2 = true;
    },
    submitFailForm() {
      if (this.repeatSave) {
        return;
      }
      if (!this.failForm.exceptionId) {
        this.$message('请选择失败原因')
        return;
      }
      this.repeatSave = true;
      updateSettlementApply({
        ...this.failForm,
        status: 2,
        operationUserName: this.userDetail.name,
      }).then(res => {
        this.repeatSave = false;
        if (res.data.success) {
          this.$message.success('打款确认成功');
          this.dialogVisible2 = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.data || res.data.message);
        }
      }).catch((err) => {
        this.repeatSave = false;
      })
    },
    showDetail(row) {
      this.detailForm = row;
      if (this.detailForm.paymentVoucherUrl) {
        if (typeof this.detailForm.paymentVoucherUrl === 'string') {
          this.detailForm.paymentVoucherUrl = JSON.parse(this.detailForm.paymentVoucherUrl)
        }
      } else {
        this.detailForm.paymentVoucherUrl = [];
      }
      this.detailForm.fileListJson=[];
      this.dialogVisible3 = true;
    },
    async voucherUpload(arr,applyId){
      this.fullscreenLoading = true;
      const res = await voucherUpload({
        applyId: applyId,
        fileListJson: JSON.stringify(arr)
      });
      this.getTableData();
      this.fullscreenLoading = false;
      console.log(res);
    },
    handleHttpRequest(option) {
      return fileUpload().then(res => {
        const client = Client(res.data.data), file = option.file;
        const random_name = new Date().getTime() + Math.random().toString() + '.' + file.name.split('.').pop();
        return client.put('tmp/' + random_name, file);
      });
    },
    handleSuccess(res, file, fileList) {
      this.successForm.fileListJson = fileList;
      if(this.dialogVisible3){//打款详情弹窗 支持回调
        const stringifyFileList =fileList.map(({name,response})=>{return{ name, url: response.url }})
        const { paymentVoucherUrl, applyId} = this.detailForm;
        const gatherArr = stringifyFileList.concat(paymentVoucherUrl);
        console.log(stringifyFileList,fileList);
        this.voucherUpload(gatherArr, applyId)
      }
    },
    onExceed() {
      this.$message('上限10个');
    },
    onRemove(file, fileList) {
      this.successForm.fileListJson = fileList;
    },
    handleExport(command) {
      switch (command) {
        case 'csv':
          this.exportTableData(2);
          break;
        case 'excel':
          this.exportTableData(1);
          break;
      }
    },
    downloadFile(blob, fileName) {
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    },
    exportTableData(exportType) {
      exportSettlementApply({
        ...this.queryForm,
        exportType,
        status: this.queryForm.status == -1 ? null : this.queryForm.status,
        startApplyAt: this.daterange[0] ? this.daterange[0] : null,
        endApplyAt: this.daterange[1] ? this.daterange[1] : null,
        startUpdateAt:  this.updateDaterange && this.updateDaterange[0] ? this.updateDaterange[0] : null,
        endUpdateAt:  this.updateDaterange && this.updateDaterange[1] ? this.updateDaterange[1] : null,
      }).then(res => {
        if (res.data.success) {
          this.getExportResult();
        } else {
          this.$message.error(res.message || '系统异常，请稍后再试');
        }
      });
    },
    downloadTemplate() {
      downloadSample().then(res => {
        const blob = res.data;
        this.downloadFile(blob, '提现审核Template.csv');
      });
    },
    async changeFile(e) {
      if (e && e.target && e.target.files && e.target.files[0]) {
        this.fullscreenLoading = true;
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        importSettlementApply(formData, {
          operationUserName: this.userDetail.name
        }).then(res => {
          if (res.data && res.data.success) {
            if (res.data.data.result) {
              this.$message.success('导入成功');
              this.getTableData();
            } else {
              this.importResult = res.data.data.remarks;
              this.dialogVisible4 = true;
            }
          } else {
            this.$message.error(res.message || '系统异常');
          }
          this.fullscreenLoading = false;
        }).catch(() => {
          this.fullscreenLoading = false;
          this.$message.error('系统异常');
        })
      }
      e.target.value = '';
    },
    getExceptionStr(id) {
      for (let i = 0; i < this.exceptionList.length; i++) {
        const item = this.exceptionList[i];
        if (item.exceptionId === id) {
          return item.reason;
        }
      }
      return '';
    },
    handleSelectionChange(val) {
      if(val){
        this.selectedAmount = val.reduce((sum,item) => sum + item.amount,0);
        this.selectedAmount = Math.round(this.selectedAmount * 100) / 100
      }else {
        this.selectedAmount = 0;
      }
      this.multipleSelection = val;
    },
    batchSuccess() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择要打款的记录');
        return;
      }
      this.successForm.amount = this.multipleSelection.reduce((prev, next) => prev + next.amount * 1000, 0) / 1000;
      this.successForm.fileListJson = [];
      this.repeatSave = false;
      this.dialogVisible5 = true;
    },
    submitBatchSuccessForm() {
      if (this.repeatSave) {
        return;
      }
      this.repeatSave = true;
      batchUpdateSettlementApply(
        this.multipleSelection.map(item => ({
          serialNumber: item.serialNumber,
          applyId: item.applyId,
          amount: item.amount,
          merchantUserName: item.merchantUserName,
          bankName: item.bankName,
          bankNumber: item.bankNumber,
          fileListJson: JSON.stringify(this.successForm.fileListJson.map(item => {
            if (item.response) {
              return {
                name: item.name,
                url: item.response.url,
              }
            }
            return {
              name: item.name,
              url: item.url,
            }
          })),
          status: 1,
          operationUserName: this.userDetail.name,
        }))
      ).then(res => {
        this.repeatSave = false;
        if (res.data.success) {
          this.$message.success('打款确认成功');
          this.dialogVisible5 = false;
          this.getTableData();
        } else {
          this.dialogVisible5 = false;
          if (res.data.message) {
            this.batchSuccessResult = res.data.message.split('\\/n').join('<br>');
          } else {
            this.batchSuccessResult = '系统异常';
          }
          this.dialogVisible6 = true;
          this.getTableData();
        }
      }).catch((err) => {
        this.repeatSave = false;
      })
    },
    getExportResult() {
      exportSettlementResult().then((res) => {
        if (res.code === '0') {
          this.exporting = true;
          this.exportFileName = '';
          this.exportFailed = false;
          this.exportTimer = setTimeout(() => {
            this.getExportResult();
          }, 2000);
        } else if (res.code === '1') {
          this.exporting = false;
          const data = JSON.parse(res.data);
          this.exportFileName = data.fileName;
          this.exportFileUrl = data.fileUrl;
          this.exportFailed = false;
          if (this.exportTimer) {
            clearTimeout(this.exportTimer);
          }
        } else if (res.code === '2') {
          this.exporting = false;
          this.exportFileName = '';
          this.exportFailed = true;
          if (this.exportTimer) {
            clearTimeout(this.exportTimer);
          }
        } else {
          this.exporting = false;
          this.exportFileName = '';
          this.exportFailed = false;
        }
      });
    },
    downloadExportResult() {
      downloadUrlFile(this.exportFileUrl);
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.red {
  color: red;
}
.ml10 {
  margin-left: 10px;
}
.ml20 {
  margin-left: 20px;
}
.mr10 {
  margin-right: 10px;
}
.mt10 {
  margin-top: 10px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
}
.title {
  font-size: 16px;
  font-weight: bold;
}
.subtitle {
  margin-top: 10px;
  font-weight: bold;
  line-height: 30px;
}
.money {
  color: red;
  font-size: 20px;
}
.ml_bold {
  margin-left: 10px;
  font-weight: bold;
  font-size: 18px;
}
dl {
  display: flex;
  font-size: 16px;
  line-height: 32px;

  dt {
    width: 100px;
    flex: 1 0 auto;
  }
  dd {
    flex: 1;
    text-align: right;
  }
}
.upload-btn {
  position: relative;
  display: inline-block;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}

.upload-withdraw {
  width: 250px;
}
</style>
<style>
.upload-withdraw .el-upload {
  text-align: right;
}
</style>
